// extracted by mini-css-extract-plugin
export default {"container":"NavbarMenu_container__L6pdL","item":"NavbarMenu_item__SnpdI","link":"NavbarMenu_link__G5O9i","counter":"NavbarMenu_counter__KrbkN"};